import React, { Component } from "react"
import { Row, Col } from "antd"
import {getStateAwareUrl} from "../../utils/utils";

class HistoryLink extends Component {
    componentDidMount() {
        console.log("props", this.props.links)
    }

    render() {
        return (
            <Row style={{ padding: "8px 0" }} type="flex" gutter={[8, 0]}>
                <Col>
                    Dashboard
                </Col>
                {
                    this.props.links?.map(({ label, link }) => (
                        <>
                            <Col style={{ textAlign: "center" }}>
                                {">"}
                            </Col>
                            <Col>
                                <a href={getStateAwareUrl(link)}>{label}</a>
                            </Col>
                        </>
                    ))
                }
            </Row>
        )
    }
}

export default HistoryLink